import { Divider, Stack, Typography } from '@mui/material';

import { CopyToClipboardButton } from '@/components/buttons/copyToClipboardButton';
import { ExtendedIconButton } from '@/components/shared/extendedIconButton';
import { Link } from '@/components/shared/link';

import { GoToJobButton } from './goToJobButton';
import { ShareResultsButton } from './shareResultsButton';
interface QueryResultsFooterProps {
  queryId?: string;
  data?: string[][];
  headerColumns?: string[];
  resultsLink?: string | null;
  executionTime?: number;
}

export const createObjectUrlLink = (
  resultLink?: string | null
): string | undefined => {
  if (!resultLink) {
    return;
  } else if (resultLink.startsWith('s3://')) {
    const consoleBase = 'https://console.aws.amazon.com/s3/buckets/';
    const resultLinkArr = resultLink.split('s3://')?.[1]?.split('/');
    const bucketName = resultLinkArr?.[0];
    const prefix = '?prefix=';
    const objectPath = resultLinkArr?.splice(1)?.join('/');
    return bucketName && prefix && objectPath
      ? `${consoleBase}${bucketName}${prefix}${objectPath}`
      : undefined;
  } else if (resultLink.startsWith('gs://')) {
    const consoleBase = 'https://console.cloud.google.com/storage/browser/';
    const resultLinkArr = resultLink.split('gs://')?.[1]?.split('/');
    const bucketName = resultLinkArr?.[0];
    const objectPath = resultLinkArr?.splice(1)?.join('/');
    return bucketName && objectPath
      ? `${consoleBase}${bucketName}/${objectPath}`
      : undefined;
  } else if (resultLink.includes('blob.core.windows.net')) {
    return resultLink;
  }
};

export function QueryResultsFooter(props: QueryResultsFooterProps) {
  const objectUrl = createObjectUrlLink(props.resultsLink);

  if (!objectUrl && !props.executionTime) {
    return null;
  }

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      width='100%'
      padding='16px 20px'
    >
      <Typography variant='subtitle1'>
        {typeof props.executionTime === 'number' &&
          props.executionTime > 0 &&
          `Records retrieved in ${(props.executionTime / 1000).toFixed(1)} seconds. Showing the first ${props.data?.length}.`}
      </Typography>
      {objectUrl && (
        <Stack
          direction='row'
          gap='24px'
          divider={<Divider orientation='vertical' flexItem variant='middle' />}
        >
          <Stack alignItems='center' direction='row' gap='8px'>
            <Typography variant='subtitle1'>Full results:</Typography>
            <VisitObjectUrlLinkButton objectUrl={objectUrl} />
            <CopyToClipboardButton
              textToCopy={objectUrl}
              tooltip='Copy object URL'
            />
          </Stack>
          <ShareResultsButton />
          {props.queryId && (
            <GoToJobButton jobId={props.queryId} jobType='restore' />
          )}
        </Stack>
      )}
    </Stack>
  );
}

export const VisitObjectUrlLinkButton = ({
  objectUrl,
}: {
  objectUrl: string;
}) => {
  return (
    <Link prefetch={false} href={objectUrl} target='_blank'>
      <ExtendedIconButton tooltip='Visit object URL'>
        <i className='material-symbols-open-in-new' />
      </ExtendedIconButton>
    </Link>
  );
};
